import { Grid, TextField, Typography } from "@material-ui/core";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import { Fragment } from "react";
import PropTypes from "prop-types";

const PrincipalProveedorForm = (props) => {
    const { title, form, handleChange, required } = props;

    const { txtRazonSocialEmpresa, txtTipoServicioSuministra } = form;

    return (
        <Fragment>
            <Grid item xs={12}>
                <Typography>{title}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    className="input-upper"
                    name={txtRazonSocialEmpresa.name}
                    label={txtRazonSocialEmpresa.label}
                    required={required}
                    value={txtRazonSocialEmpresa.value}
                    error={txtRazonSocialEmpresa.required && txtRazonSocialEmpresa.error}
                    helperText={txtRazonSocialEmpresa.required && txtRazonSocialEmpresa.error && txtRazonSocialEmpresa.helper}
                    onChange={handleChange}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    inputProps={{
                        maxLength: 200,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    className="input-upper"
                    name={txtTipoServicioSuministra.name}
                    label={txtTipoServicioSuministra.label}
                    required={required}
                    value={txtTipoServicioSuministra.value}
                    error={txtTipoServicioSuministra.required && txtTipoServicioSuministra.error}
                    helperText={txtTipoServicioSuministra.required && txtTipoServicioSuministra.error && txtTipoServicioSuministra.helper}
                    onChange={handleChange}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    inputProps={{
                        maxLength: 200,
                    }}
                />
            </Grid>
        </Fragment>
    );
};

PrincipalProveedorForm.propTypes = {
    form: PropTypes.shape({
        txtRazonSocialEmpresa: PropTypes.shape({
            error: PropTypes.any,
            helper: PropTypes.any,
            label: PropTypes.any,
            name: PropTypes.any,
            required: PropTypes.any,
            value: PropTypes.any,
        }),
        txtTipoServicioSuministra: PropTypes.shape({
            error: PropTypes.any,
            helper: PropTypes.any,
            label: PropTypes.any,
            name: PropTypes.any,
            required: PropTypes.any,
            value: PropTypes.any,
        }),
    }),
    handleChange: PropTypes.any,
    required: PropTypes.any,
    title: PropTypes.any,
};

export default PrincipalProveedorForm;
